import { NgModule, Inject, PLATFORM_ID, ErrorHandler } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AppCommonModule } from './app.common.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule, PERSISTENCE } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { AngularFireRemoteConfig, AngularFireRemoteConfigModule, DEFAULTS, SETTINGS } from '@angular/fire/compat/remote-config';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { StockOverviewModule } from './modules/stock-overview/stock-overview.module';
import { RibaModalComponent } from './shared/components/riba-modal/riba-modal.component';
import { PreTradingPopupComponent } from './shared/components/pre-trading-popup/pre-trading-popup.component';
import { sidebarMetaReducer } from './stores/sidebar/sidebar.meta-reducer';
import { DisclaimerPopupComponent } from './shared/components/disclaimer-popup/disclaimer-popup.component';
import { InvestInvitationPopupComponent } from './shared/components/invest-invitation-popup/invest-invitation-popup.component';
import { AssetSearchModalComponent } from './shared/components/asset-search-modal/asset-search-modal.component';
import { UrlSerializer } from '@angular/router';
import { TrailingSlashUrlSerializer } from './shared/functions/trailing-slash-url-serializer';
import { GlobalErrorHandlerService } from './core/services/global-error-handler.service';


@NgModule({
   imports: [
      AppCommonModule,
      AngularFireModule.initializeApp(environment.firebase),
      AngularFirestoreModule,
      AngularFireAuthModule,
      AngularFireRemoteConfigModule,
      AngularFireDatabaseModule,
      AngularFireAnalyticsModule,
   ],
   providers: [
      {
         provide: PERSISTENCE,
         useFactory: (platformId: Object) => {
            return isPlatformBrowser(platformId) ? 'local' : 'none';
         },
         deps: [PLATFORM_ID]
      },
      { provide: DEFAULTS, useValue: environment.defaultRemoteConfig },
      {
         provide: SETTINGS,
         useFactory: () => ({
            minimumFetchIntervalMillis: 120000,
            fetchTimeoutMillis: 60000
         }),
      },
      provideFirestore(() => getFirestore()),
      { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
      { provide: UrlSerializer, useClass: TrailingSlashUrlSerializer }
      // ScriptLoaderService,
   ],
   bootstrap: [AppComponent]
})
export class AppModule {
   constructor(
      private remoteConfig: AngularFireRemoteConfig,
      @Inject(PLATFORM_ID) private platformId: Object
   ) {
      if (isPlatformBrowser(this.platformId)) {
         this.initializeRemoteConfig();
      }
   }

   private async initializeRemoteConfig(): Promise<void> {
      try {
         const settings = await this.remoteConfig.settings;
         settings.fetchTimeoutMillis = 60000;
         settings.minimumFetchIntervalMillis = 120000;
         await this.remoteConfig.fetchAndActivate();
      } catch (error) {
         console.error('Remote config initialization failed:', error);
      }
   }
}
